module.exports = __webpack_public_path__ + "img/1inchdown.9abd25fc.svg";